import * as React from 'react';
import { useEffect, useState } from 'react';
import { TeamManagementView, TeamManagementViewProps } from './TeamManagement.view';
import { useSelectedOrganization } from '../../../hooks/useSelectedOrganization';
import { SettingsTeamMember } from '../../../models/settings-pages';
import {
  sortArrayOfTeamMembers,
  mapOrganizationInvitationsToTeamMembersType,
  mapOrganizationUsersToTeamMembersType
} from '../../../helpers/teamMembers';

export type TeamManagementControllerProps = Omit<
  TeamManagementViewProps,
  | 'selectedMember'
  | 'openInviteModal'
  | 'setOpenInviteModal'
  | 'openRemoveModal'
  | 'setOpenRemoveModal'
  | 'openRemoveMemberModal'
  | 'sortedUserAssignmentsAndInvites'
  | 'handleWorkspaceAssignmentToggle'
  | 'handleUserRoleChange'
  | 'updateInvitedMemberRole'
> & {
  // ...
};

export const TeamManagementController = (props: TeamManagementControllerProps): JSX.Element => {
  const { selectedOrganization } = useSelectedOrganization();
  const [openInviteModal, setOpenInviteModal] = useState<boolean>(false);

  // Get the organization details each time its changed
  useEffect(() => {
    if (selectedOrganization) {
      props.getOrganization({
        variables: { organizationId: selectedOrganization.id }
      });
    }
    // TODO-FIX-TS-WARNINGS
    // eslint-disable-next-line
  }, [selectedOrganization]);

  const organization = props.organizationResults?.data?.organization;
  let teamMembers: SettingsTeamMember[] = [];
  let sortedUserAssignmentsAndInvites = undefined;

  if (organization) {
    teamMembers = [
      ...mapOrganizationUsersToTeamMembersType(organization),
      ...mapOrganizationInvitationsToTeamMembersType(organization)
    ];
    sortedUserAssignmentsAndInvites = sortArrayOfTeamMembers(teamMembers);
  }

  const viewProps: TeamManagementViewProps = {
    ...props,
    openInviteModal,
    setOpenInviteModal,
    sortedUserAssignmentsAndInvites
  };

  return <TeamManagementView {...viewProps} />;
};
